import { useTranslations } from 'next-intl';

import { LoginPage } from '@zapier/auth-pages';
import Head from 'next/head';
import { PageLayout, Title } from '../../../components';

export default function Login() {
  const t = useTranslations('login-page');

  return (
    <>
      <Head>
        <link rel="canonical" href="https://zapier.com/app/login" />
      </Head>
      <Title title={t('page-title')}>
        <PageLayout>
          <LoginPage />
        </PageLayout>
      </Title>
    </>
  );
}
